import type { Variants } from 'framer-motion'
import type { AnimationType } from './types'
import {
  defaultContainerVariants,
  defaultItemVariants,
  defaultItemAnimationVariants,
} from './constants'

export const splitTextByType = (text: string, by: AnimationType): string[] => {
  switch (by) {
    case 'word':
      return text.split(/(\s+)/)
    case 'character':
      return text.split('')
    case 'line':
      return text.split('\n')
    default:
      return [text]
  }
}

export const createSegmentKey = (segment: string, by: AnimationType): string => {
  const segmentHash = segment
    .split('')
    .reduce((acc, char, idx) => acc + char.charCodeAt(0) * (idx + 1), 0)

  return `${by}-${segment.trim() || `space-${segmentHash}`}-hash${segmentHash}`
}

export const buildFinalVariants = (
  variants: Variants | undefined,
  animation: string,
  delay: number,
  duration: number,
  segmentsLength: number,
) => {
  const staggerDuration = duration / Math.max(segmentsLength, 1)

  if (variants) {
    return {
      container: {
        hidden: { opacity: 0 },
        show: {
          opacity: 1,
          transition: {
            opacity: { duration: 0.01, delay },
            delayChildren: delay,
            staggerChildren: staggerDuration,
          },
        },
        exit: {
          opacity: 0,
          transition: {
            staggerChildren: staggerDuration,
            staggerDirection: -1,
          },
        },
      },
      item: variants,
    }
  }

  if (animation && animation in defaultItemAnimationVariants) {
    const animationKey = animation as keyof typeof defaultItemAnimationVariants
    return {
      container: {
        ...defaultItemAnimationVariants[animationKey].container,
        show: {
          ...defaultItemAnimationVariants[animationKey].container.show,
          transition: {
            delayChildren: delay,
            staggerChildren: staggerDuration,
          },
        },
        exit: {
          ...defaultItemAnimationVariants[animationKey].container.exit,
          transition: {
            staggerChildren: staggerDuration,
            staggerDirection: -1,
          },
        },
      },
      item: defaultItemAnimationVariants[animationKey].item,
    }
  }

  return {
    container: defaultContainerVariants,
    item: defaultItemVariants,
  }
}
